import { ChatProps } from './types'

export const DEFAULT_ENDPOINTS: ChatProps['apiEndpoints'] = {
  message: '/api/anonymous/chat/message',
  rating: '/api/anonymous/chat/rating',
}
